import { render, staticRenderFns } from "./Masterdatavalue.vue?vue&type=template&id=84f1cad8&scoped=true"
import script from "./Masterdatavalue.vue?vue&type=script&lang=js"
export * from "./Masterdatavalue.vue?vue&type=script&lang=js"
import style0 from "./Masterdatavalue.vue?vue&type=style&index=0&id=84f1cad8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f1cad8",
  null
  
)

export default component.exports